import styled from 'styled-components'
import FinancialVariantEnum from '../../enums/FinancialVariantEnum'
import pxToRem from '../../utils/pxToRem'
import ButtonDownload from '../ButtonDownload/ButtonDownload'
import {deviceMax} from "../../theme/breakpoints";

export const StyledContent = styled.div`
  width: ${pxToRem(173)};
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(20)};
  ${({$variant}) =>
          $variant === FinancialVariantEnum.investor && `width: 100%`};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
`

export const StyledContentTitle = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  height: ${pxToRem(20)};
  width: 100%;
  font-size: ${({theme}) => theme.fonts.sizes.button};
  line-height: ${({theme}) => theme.fonts.lineHeight.button};
`

export const StyledBold = styled.span`
  font-weight: ${({theme}) => theme.fonts.weight.bold};
`

export const StyledButtonDownload = styled(ButtonDownload)`
  max-width: ${pxToRem(364)};
  min-width: 45%;

  @media ${deviceMax.tablet} {
    max-width: ${pxToRem(320)};
  }
  @media ${deviceMax.mobileL} {
    width: 100%;
    max-width: ${pxToRem(320)};
    min-width: none;
  }
`
